import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import HELPERS from '../../utils/helper';
import { ToastMessage, Toast, toastMsgConfig } from '../toast';
import apis from '../../config/apis';
import { ErrorMessageHandling } from '../error';
import { getClientConfig } from '../../config/clientConfig';
import './template13.css';

// Modern App-Style Template - Clean Version (No Banner, Stats, or Why Choose Us)
class EnquiryTemplate13 extends Component {
  constructor(props) {
    super(props);

    const clientConfig = getClientConfig(props.clientId);

    if (!clientConfig) {
      this.state = {
        loader: false,
        clientConfig: null,
        formData: {},
        errors: {},
        disabled: true,
        areas: [],
        courses: [],
      };
      return;
    }

    this.state = {
      loader: false,
      formData: {
        // Personal Information
        studentFullName: '',
        gender: '',
        dateOfBirth: '',

        // Contact Information
        studentMobile: '',
        parentMobile: '',
        email: '',

        // Parent Information
        parentName: '',
        parentOccupation: '',

        // Address Information
        state: '',
        city: '',
        pincode: '',
        permanentAddress: '',
        correspondenceAddress: '',
        sameAsPermAddress: false,

        // Course Information
        course: '',
        examTargeting: 'UPSC',
        mediumOfAnswerWriting: 'Marathi',

        // Educational Qualifications
        qualification: '',
        yearOfPassing: '',

        // Declaration
        declarationAccepted: false
      },
      errors: {},
      disabled: false,
      areas: [],
      states: [],
      cities: [],
      clientConfig: clientConfig,
      courses: clientConfig.courses
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.fetchStates();
    this.fetchCourses();
  }

  fetchStates = async () => {
    try {
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*'
        }
      };

      const statesUrl = 'https://api.proctur.com/StdMgmtWebAPI/api/v1/country/state?country_ids=1';
      const res = await HELPERS.ApiCall(statesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data && res.data.result) {
        const result = res.data.result;
        const states = [];

        if (Array.isArray(result)) {
          result.forEach(country => {
            if (country.stateList && Array.isArray(country.stateList)) {
              country.stateList.forEach(state => {
                if (state.state_name) {
                  states.push({
                    stateId: state.state_id,
                    stateName: state.state_name
                  });
                }
              });
            }
          });
        }

        if (states.length > 0) {
          this.setState({ states });
        } else {
          this.useFallbackStates();
        }
      } else {
        this.useFallbackStates();
      }
    } catch (err) {
      console.error('Error fetching states:', err);
      this.useFallbackStates();
    }
  }

  useFallbackStates = () => {
    this.setState({
      states: [
        { stateId: 5, stateName: 'Gujarat' }
      ]
    });
  }

  fetchCities = async (stateId) => {
    try {
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*'
        }
      };

      const citiesUrl = `https://api.proctur.com/StdMgmtWebAPI/api/v1/country/city?state_ids=${stateId}`;
      const res = await HELPERS.ApiCall(citiesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data && res.data.result) {
        const result = res.data.result;
        const cities = [];

        if (Array.isArray(result)) {
          result.forEach(state => {
            if (state.cityList && Array.isArray(state.cityList)) {
              state.cityList.forEach(city => {
                if (city.city_name) {
                  cities.push({
                    cityId: city.city_id,
                    cityName: city.city_name
                  });
                }
              });
            }
          });
        }

        if (cities.length > 0) {
          this.setState({ cities });
        } else {
          this.setState({ cities: [] });
        }
      } else {
        this.setState({ cities: [] });
      }
    } catch (err) {
      console.error('Error fetching cities:', err);
      this.setState({ cities: [] });
    }
  }

  fetchAreas = async (cityId) => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*'
        }
      };

      const areasUrl = `https://api.proctur.com/StdMgmtWebAPI/api/v1/cityArea/area/${clientConfig.instituteId}?city_ids=${cityId}`;
      const res = await HELPERS.ApiCall(areasUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const result = res.data.result || res.data.data || res.data;
        const areas = [];

        if (Array.isArray(result)) {
          result.forEach(item => {
            if (item.areaList && Array.isArray(item.areaList)) {
              item.areaList.forEach(areaObj => {
                if (areaObj.area) {
                  areas.push({
                    areaId: areaObj.id,
                    areaName: areaObj.area
                  });
                }
              });
            }
          });
        }

        if (areas.length > 0) {
          this.setState({ areas });
        } else {
          this.setState({ areas: [] });
        }
      } else {
        this.setState({ areas: [] });
      }
    } catch (err) {
      console.error('Error fetching areas:', err);
      this.setState({ areas: [] });
    }
  }

  useFallbackAreas = () => {
    this.setState({
      areas: []
    });
  }

  fetchCourses = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
        }
      };

      const coursesUrl = apis.getCoursesUrl(clientConfig);
      const res = await HELPERS.ApiCall(coursesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const courseList = res.data.data || res.data;
        const courses = [];

        if (Array.isArray(courseList)) {
          courseList.forEach(item => {
            if (item.master_course) {
              courses.push(item.master_course);
            }
          });
        }

        if (courses.length > 0) {
          this.setState({ courses });
        } else {
          this.useFallbackCourses();
        }
      } else {
        this.useFallbackCourses();
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
      this.useFallbackCourses();
    }
  }

  useFallbackCourses = () => {
    const { clientConfig } = this.state;
    if (clientConfig && clientConfig.courses) {
      this.setState({ courses: clientConfig.courses });
    }
  }

  showMessage = (type, message) => {
    Toast(message, toastMsgConfig(type));
  }

  handleInputChange = (field, value) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [field]: value
      },
      errors: {
        ...this.state.errors,
        [field]: ''
      }
    });
  }

  handleAddressCheckbox = (checked) => {
    this.setState({
      formData: {
        ...this.state.formData,
        sameAsPermAddress: checked,
        correspondenceAddress: checked ? this.state.formData.permanentAddress : ''
      }
    });
  }


  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    // Personal Information
    if (!formData.studentFullName.trim()) {
      errors.studentFullName = 'Student full name is required';
    } else if (formData.studentFullName.trim().length < 2) {
      errors.studentFullName = 'Name must be at least 2 characters';
    }

    if (!formData.gender) {
      errors.gender = 'Gender is required';
    }

    if (!formData.dateOfBirth) {
      errors.dateOfBirth = 'Date of birth is required';
    }

    // Contact Information
    if (!formData.studentMobile.trim()) {
      errors.studentMobile = 'Student mobile number is required';
    } else if (!/^[0-9]{10}$/.test(formData.studentMobile.replace(/\s/g, ''))) {
      errors.studentMobile = 'Please enter a valid 10-digit mobile number';
    }

    if (!formData.parentMobile.trim()) {
      errors.parentMobile = 'Parent mobile number is required';
    } else if (!/^[0-9]{10}$/.test(formData.parentMobile.replace(/\s/g, ''))) {
      errors.parentMobile = 'Please enter a valid 10-digit mobile number';
    }

    if (!formData.email.trim()) {
      errors.email = 'Email address is required';
    } else if (!HELPERS.validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    // Parent Information
    if (!formData.parentName.trim()) {
      errors.parentName = 'Parent name is required';
    } else if (formData.parentName.trim().length < 2) {
      errors.parentName = 'Name must be at least 2 characters';
    }

    if (!formData.parentOccupation.trim()) {
      errors.parentOccupation = 'Parent occupation is required';
    }

    // Address Information
    if (!formData.permanentAddress.trim()) {
      errors.permanentAddress = 'Permanent address is required';
    }

    if (!formData.correspondenceAddress.trim()) {
      errors.correspondenceAddress = 'Correspondence address is required';
    }

    // Course Information
    if (!formData.course) {
      errors.course = 'Please select a course';
    }

    if (!formData.examTargeting) {
      errors.examTargeting = 'Please select exam you are targeting';
    }

    if (!formData.mediumOfAnswerWriting) {
      errors.mediumOfAnswerWriting = 'Please select medium of answer writing';
    }

    // Educational Qualifications - Optional fields
    // No validation needed as these are optional

    // Declaration
    if (!formData.declarationAccepted) {
      errors.declarationAccepted = 'You must accept the declaration';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit = async () => {
    this.setState({ disabled: true });

    // Check rate limiting - max 3 submissions per minute
    if (!HELPERS.checkRateLimit('form_submission', 3, 60000)) {
      this.setState({ disabled: false });
      this.showMessage('e', 'Too many submissions. Please wait a minute before trying again.');
      return;
    }

    if (!this.validateForm()) {
      this.setState({ disabled: false });
      this.showMessage('e', 'Please correct the errors in the form');
      return;
    }

    this.setState({ loader: true });

    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Authorization': clientConfig.api.authorization,
          'Content-Type': 'application/json',
          'source': 'WEB',
          'accept': 'application/json, text/plain, */*'
        }
      };

      // Build customComponentList dynamically
      const customComponentList = [
        {
          label: 'Qualification',
          enq_custom_value: this.state.formData.qualification
        },
        {
          label: 'Yr. Of Passing',
          enq_custom_value: this.state.formData.yearOfPassing
        },
        {
          label: 'Exam You Are Targeting',
          enq_custom_value: this.state.formData.examTargeting
        },
        {
          label: 'Medium of Answer Writing',
          enq_custom_value: this.state.formData.mediumOfAnswerWriting
        }
      ];

      // Add Subject/Discipline if checkbox is checked
      if (this.state.formData.sameAsPermAddress) {
        customComponentList.push({
          label: 'Subject/Discipline',
          enq_custom_value: 'Y'
        });
      }

      const payload = {
        name: this.state.formData.studentFullName,
        mobile: this.state.formData.studentMobile,
        email: this.state.formData.email,
        comments: '',
        institute_id: clientConfig.instituteId,
        customComponentList: customComponentList,
        mCourseName: this.state.formData.course,
        state: this.state.formData.state || clientConfig.api.defaults.state,
        city: this.state.formData.city || clientConfig.api.defaults.city,
        area: this.state.formData.pincode || clientConfig.api.defaults.defaultArea,
        dob: this.state.formData.dateOfBirth,
        gender: this.state.formData.gender === 'Male' ? 'M' : (this.state.formData.gender === 'Female' ? 'F' : ''),
        address: this.state.formData.correspondenceAddress,
        permanentAddress: this.state.formData.permanentAddress,
        parentName: this.state.formData.parentName,
        parentOccupation: this.state.formData.parentOccupation,
        parentMobile: this.state.formData.parentMobile
      };

      const apiUrl = apis.getApiUrl(clientConfig);
      const res = await HELPERS.ApiCall(apiUrl, payload, 'POST', 'proctur', headers);

      if (res.status === 200 && res.data.statusCode === 200) {
        this.setState({
          loader: false,
          formData: {
            studentFullName: '',
            gender: '',
            dateOfBirth: '',
            studentMobile: '',
            parentMobile: '',
            email: '',
            parentName: '',
            parentOccupation: '',
            state: '',
            city: '',
            pincode: '',
            permanentAddress: '',
            correspondenceAddress: '',
            sameAsPermAddress: false,
            course: '',
            examTargeting: 'UPSC',
            mediumOfAnswerWriting: 'Marathi',
            qualification: '',
            yearOfPassing: '',
            declarationAccepted: false
          },
          disabled: false,
          errors: {}
        });
        this.showMessage('s', 'Registration submitted successfully! Our admissions team will contact you within 24 hours.');
      } else {
        this.showMessage('e', res.data.message || 'Something went wrong. Please try again.');
        this.setState({ loader: false, disabled: false });
      }
    } catch (err) {
      if (err.response && err.response.status === 403) {
        this.props.dispatch({
          type: 'LOGOUT',
          message: err.response.data?.message || 'Session expired'
        });
      } else {
        this.showMessage('e', ErrorMessageHandling(err));
      }
      this.setState({ loader: false, disabled: false });
    }
  }

  render() {
    const { formData, errors, disabled, loader, courses, clientConfig } = this.state;

    if (!clientConfig) {
      return null;
    }

    // Calculate form completion percentage
    const requiredFields = [
      'studentFullName', 'gender', 'dateOfBirth', 'studentMobile', 'parentMobile',
      'email', 'parentName', 'parentOccupation', 'permanentAddress', 'correspondenceAddress', 'course', 'examTargeting', 'mediumOfAnswerWriting'
    ];
    const completedFields = requiredFields.filter(field => {
      const value = formData[field];
      return value && (typeof value === 'string' ? value.trim() : true);
    }).length;

    // Add points for declaration
    let totalFields = requiredFields.length + 1; // +1 for declaration
    let completed = completedFields;

    if (formData.declarationAccepted) completed++;

    const completionPercentage = Math.round((completed / totalFields) * 100);

    return (
      <>
        {loader && (
          <div className="template13-loader">
            <div className="template13-loading-spinner"></div>
            <p>Submitting your enquiry...</p>
          </div>
        )}
        <ToastMessage />

        <div className="template13-app">
          {/* App Header - Enhanced */}
          <header className="template13-header">
            <div className="template13-header-content">
              <div className="template13-logo-wrapper">
                <div className="template13-logo">
                  <img src={clientConfig.branding.logo} alt={clientConfig.clientName} />
                </div>
                <div className="template13-header-info">
                  <h1>{clientConfig.clientName}</h1>
                  <p className="template13-subtitle">{clientConfig.branding.heroSubtitle}</p>
                </div>
              </div>
              <span className="template13-badge">{clientConfig.branding.badgeText}</span>
            </div>
          </header>

          {/* Main Content Container */}
          <div className="template13-content">
            {/* Registration Form Card - Compact */}
            <div className="template13-form-card">
              <div className="template13-form-header">
                <h2>Student Registration Form</h2>
                <p>Fill in all the required fields below</p>
              </div>

              <form className="template13-form" onSubmit={(e) => e.preventDefault()}>
                {/* Section 1: Student Personal Information */}
                <div className="template13-section">
                  <div className="template13-section-header">
                    <h3><i className="fa fa-user-graduate"></i> Student Personal Information</h3>
                  </div>
                  <div className="template13-input-grid">
                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-user"></i>
                        Student Full Name <span className="template13-required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`template13-input ${errors.studentFullName ? 'template13-error' : ''} ${formData.studentFullName ? 'template13-filled' : ''}`}
                        placeholder="Enter student's full name"
                        value={formData.studentFullName}
                        onChange={(e) => this.handleInputChange('studentFullName', e.target.value)}
                      />
                      {errors.studentFullName && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.studentFullName}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-venus-mars"></i>
                        Gender <span className="template13-required">*</span>
                      </label>
                      <select
                        className={`template13-input template13-select ${errors.gender ? 'template13-error' : ''} ${formData.gender ? 'template13-filled' : ''}`}
                        value={formData.gender}
                        onChange={(e) => this.handleInputChange('gender', e.target.value)}
                      >
                        <option value="">Select gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                      {errors.gender && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.gender}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-calendar"></i>
                        Date of Birth <span className="template13-required">*</span>
                      </label>
                      <input
                        type="date"
                        className={`template13-input ${errors.dateOfBirth ? 'template13-error' : ''} ${formData.dateOfBirth ? 'template13-filled' : ''}`}
                        value={formData.dateOfBirth}
                        onChange={(e) => this.handleInputChange('dateOfBirth', e.target.value)}
                      />
                      {errors.dateOfBirth && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.dateOfBirth}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-mobile-alt"></i>
                        Student's Mobile Number <span className="template13-required">*</span>
                      </label>
                      <input
                        type="tel"
                        className={`template13-input ${errors.studentMobile ? 'template13-error' : ''} ${formData.studentMobile ? 'template13-filled' : ''}`}
                        placeholder="10-digit mobile number"
                        value={formData.studentMobile}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          if (value.length <= 10) {
                            this.handleInputChange('studentMobile', value);
                          }
                        }}
                      />
                      {errors.studentMobile && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.studentMobile}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-envelope"></i>
                        Email Address <span className="template13-required">*</span>
                      </label>
                      <input
                        type="email"
                        className={`template13-input ${errors.email ? 'template13-error' : ''} ${formData.email ? 'template13-filled' : ''}`}
                        placeholder="your@email.com"
                        value={formData.email}
                        onChange={(e) => this.handleInputChange('email', e.target.value)}
                      />
                      {errors.email && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.email}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-map"></i>
                        State
                      </label>
                      <select
                        className={`template13-input template13-select ${formData.state ? 'template13-filled' : ''}`}
                        value={formData.state}
                        onChange={(e) => {
                          const selectedState = this.state.states.find(s => s.stateName === e.target.value);
                          const newFormData = { ...this.state.formData, state: e.target.value, city: '', pincode: '' };
                          this.setState({ formData: newFormData, cities: [], areas: [] });
                          if (selectedState) {
                            this.fetchCities(selectedState.stateId);
                          }
                        }}
                      >
                        <option value="">Select state</option>
                        {this.state.states.map((state, index) => (
                          <option key={index} value={state.stateName}>{state.stateName}</option>
                        ))}
                      </select>
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-city"></i>
                        City
                      </label>
                      <select
                        className={`template13-input template13-select ${formData.city ? 'template13-filled' : ''}`}
                        value={formData.city}
                        onChange={(e) => {
                          const selectedCity = this.state.cities.find(c => c.cityName === e.target.value);
                          const newFormData = { ...this.state.formData, city: e.target.value, pincode: '' };
                          this.setState({ formData: newFormData, areas: [] });
                          if (selectedCity) {
                            this.fetchAreas(selectedCity.cityId);
                          }
                        }}
                        disabled={!formData.state || this.state.cities.length === 0}
                      >
                        <option value="">Select city</option>
                        {this.state.cities.map((city, index) => (
                          <option key={index} value={city.cityName}>{city.cityName}</option>
                        ))}
                      </select>
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-map-pin"></i>
                        Area
                      </label>
                      <select
                        className={`template13-input template13-select ${formData.pincode ? 'template13-filled' : ''}`}
                        value={formData.pincode}
                        onChange={(e) => this.handleInputChange('pincode', e.target.value)}
                        disabled={!formData.city || this.state.areas.length === 0}
                      >
                        <option value="">Select area</option>
                        {this.state.areas.map((area, index) => (
                          <option key={index} value={area.areaName}>{area.areaName}</option>
                        ))}
                      </select>
                    </div>

                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-home"></i>
                        Permanent Address <span className="template13-required">*</span>
                      </label>
                      <textarea
                        className={`template13-input template13-textarea ${errors.permanentAddress ? 'template13-error' : ''} ${formData.permanentAddress ? 'template13-filled' : ''}`}
                        placeholder="Enter permanent address"
                        rows="3"
                        value={formData.permanentAddress}
                        onChange={(e) => this.handleInputChange('permanentAddress', e.target.value)}
                      />
                      {errors.permanentAddress && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.permanentAddress}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group template13-full-width">
                      <div className="template13-checkbox-wrapper">
                        <input
                          type="checkbox"
                          id="sameAsPermAddress"
                          checked={formData.sameAsPermAddress}
                          onChange={(e) => this.handleAddressCheckbox(e.target.checked)}
                        />
                        <label htmlFor="sameAsPermAddress">
                          Correspondence address same as permanent address
                        </label>
                      </div>
                    </div>

                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-map-marked-alt"></i>
                        Correspondence Address <span className="template13-required">*</span>
                      </label>
                      <textarea
                        className={`template13-input template13-textarea ${errors.correspondenceAddress ? 'template13-error' : ''} ${formData.correspondenceAddress ? 'template13-filled' : ''}`}
                        placeholder="Enter correspondence address"
                        rows="3"
                        value={formData.correspondenceAddress}
                        onChange={(e) => this.handleInputChange('correspondenceAddress', e.target.value)}
                        disabled={formData.sameAsPermAddress}
                      />
                      {errors.correspondenceAddress && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.correspondenceAddress}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Section 2: Parent Information */}
                <div className="template13-section">
                  <div className="template13-section-header">
                    <h3><i className="fa fa-users"></i> Parent Information</h3>
                  </div>
                  <div className="template13-input-grid">
                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-user"></i>
                        Parent's Name <span className="template13-required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`template13-input ${errors.parentName ? 'template13-error' : ''} ${formData.parentName ? 'template13-filled' : ''}`}
                        placeholder="Enter parent's full name"
                        value={formData.parentName}
                        onChange={(e) => this.handleInputChange('parentName', e.target.value)}
                      />
                      {errors.parentName && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.parentName}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-phone"></i>
                        Parent's Mobile Number <span className="template13-required">*</span>
                      </label>
                      <input
                        type="tel"
                        className={`template13-input ${errors.parentMobile ? 'template13-error' : ''} ${formData.parentMobile ? 'template13-filled' : ''}`}
                        placeholder="10-digit mobile number"
                        value={formData.parentMobile}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          if (value.length <= 10) {
                            this.handleInputChange('parentMobile', value);
                          }
                        }}
                      />
                      {errors.parentMobile && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.parentMobile}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-briefcase"></i>
                        Parent's Occupation <span className="template13-required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`template13-input ${errors.parentOccupation ? 'template13-error' : ''} ${formData.parentOccupation ? 'template13-filled' : ''}`}
                        placeholder="Enter parent's occupation"
                        value={formData.parentOccupation}
                        onChange={(e) => this.handleInputChange('parentOccupation', e.target.value)}
                      />
                      {errors.parentOccupation && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.parentOccupation}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Section 3: Enrolling Course Information */}
                <div className="template13-section">
                  <div className="template13-section-header">
                    <h3><i className="fa fa-graduation-cap"></i> Enrolling Course Information</h3>
                  </div>
                  <div className="template13-input-grid">
                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-graduation-cap"></i>
                        Select Course <span className="template13-required">*</span>
                      </label>
                      <select
                        className={`template13-input template13-select ${errors.course ? 'template13-error' : ''} ${formData.course ? 'template13-filled' : ''}`}
                        value={formData.course}
                        onChange={(e) => this.handleInputChange('course', e.target.value)}
                      >
                        <option value="">Choose your program</option>
                        {courses.map((course, index) => (
                          <option key={index} value={course}>
                            {course}
                          </option>
                        ))}
                      </select>
                      {errors.course && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.course}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-bullseye"></i>
                        Exam You Are Targeting <span className="template13-required">*</span>
                      </label>
                      <select
                        className={`template13-input template13-select ${errors.examTargeting ? 'template13-error' : ''} ${formData.examTargeting ? 'template13-filled' : ''}`}
                        value={formData.examTargeting}
                        onChange={(e) => this.handleInputChange('examTargeting', e.target.value)}
                      >
                        <option value="UPSC">UPSC</option>
                        <option value="MPSC">MPSC</option>
                      </select>
                      {errors.examTargeting && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.examTargeting}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-language"></i>
                        Medium of Answer Writing <span className="template13-required">*</span>
                      </label>
                      <select
                        className={`template13-input template13-select ${errors.mediumOfAnswerWriting ? 'template13-error' : ''} ${formData.mediumOfAnswerWriting ? 'template13-filled' : ''}`}
                        value={formData.mediumOfAnswerWriting}
                        onChange={(e) => this.handleInputChange('mediumOfAnswerWriting', e.target.value)}
                      >
                        <option value="Marathi">Marathi</option>
                        <option value="English">English</option>
                        <option value="Hindi">Hindi</option>
                      </select>
                      {errors.mediumOfAnswerWriting && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.mediumOfAnswerWriting}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-book"></i>
                        Highest Qualification
                      </label>
                      <input
                        type="text"
                        className={`template13-input ${formData.qualification ? 'template13-filled' : ''}`}
                        placeholder="e.g., 10th, 12th, B.A., B.Tech"
                        value={formData.qualification}
                        onChange={(e) => this.handleInputChange('qualification', e.target.value)}
                      />
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-calendar-alt"></i>
                        Passing Year
                      </label>
                      <input
                        type="text"
                        className={`template13-input ${formData.yearOfPassing ? 'template13-filled' : ''}`}
                        placeholder="e.g., 2020, 2021, 2022"
                        value={formData.yearOfPassing}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          if (value.length <= 4) {
                            this.handleInputChange('yearOfPassing', value);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Declaration Section */}
                <div className="template13-section">
                  <div className="template13-input-grid">
                    <div className="template13-input-group template13-full-width">
                      <div className="template13-declaration-section">
                        <div className={`template13-declaration-box ${errors.declarationAccepted ? 'template13-error' : ''}`}>
                          <h4>Declaration by the Student</h4>
                          <p>
                            I HEREBY DECLARE THAT THE ABOVE INFORMATION IS TRUE TO THE BEST OF MY KNOWLEDGE.
                            IF THIS INFORMATION IS FOUND TO BE FALSE THEN MY ADMISSION CANCELLED BY THE INSTITUTE.
                          </p>

                          <div className="template13-checkbox-wrapper template13-declaration-checkbox">
                            <input
                              type="checkbox"
                              id="declarationAccepted"
                              checked={formData.declarationAccepted}
                              onChange={(e) => this.handleInputChange('declarationAccepted', e.target.checked)}
                            />
                            <label htmlFor="declarationAccepted">
                              I accept the above declaration <span className="template13-required">*</span>
                            </label>
                          </div>
                          {errors.declarationAccepted && (
                            <span className="template13-error-text">
                              <i className="fa fa-exclamation-circle"></i> {errors.declarationAccepted}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="template13-submit-wrapper">
                  <button
                    type="button"
                    className={`template13-submit-btn ${disabled ? 'template13-disabled' : ''}`}
                    onClick={this.handleSubmit}
                    disabled={disabled}
                  >
                    {loader ? (
                      <>
                        <i className="fa fa-spinner fa-spin"></i>
                        <span>Processing your registration...</span>
                      </>
                    ) : (
                      <>
                        <i className="fa fa-paper-plane"></i>
                        <span>Submit Registration</span>
                        <i className="fa fa-arrow-right"></i>
                      </>
                    )}
                  </button>

                  <div className="template13-form-footer">
                    <i className="fa fa-lock"></i>
                    <span>Your information is secure and will be kept confidential</span>
                  </div>
                </div>
              </form>
            </div>

            {/* Contact Info Card - Enhanced */}
            <div className="template13-sidebar">

              <div className="template13-contact-card">
                <h3>
                  <i className="fa fa-headset"></i>
                  Contact Information
                </h3>
                <div className="template13-contact-list">
                  <a href={`tel:${clientConfig.contactInfo.phone1}`} className="template13-contact-item">
                    <div className="template13-contact-icon">
                      <i className="fa fa-phone"></i>
                    </div>
                    <div className="template13-contact-details">
                      <span className="template13-contact-label">Call Us</span>
                      <span className="template13-contact-value">{clientConfig.contactInfo.phone1}</span>
                    </div>
                    <i className="fa fa-chevron-right template13-contact-arrow"></i>
                  </a>

                  <a href={`mailto:${clientConfig.contactInfo.email}`} className="template13-contact-item">
                    <div className="template13-contact-icon">
                      <i className="fa fa-envelope"></i>
                    </div>
                    <div className="template13-contact-details">
                      <span className="template13-contact-label">Email Us</span>
                      <span className="template13-contact-value">{clientConfig.contactInfo.email}</span>
                    </div>
                    <i className="fa fa-chevron-right template13-contact-arrow"></i>
                  </a>

                  <div className="template13-contact-item template13-address-item">
                    <div className="template13-contact-icon">
                      <i className="fa fa-map-marker-alt"></i>
                    </div>
                    <div className="template13-contact-details">
                      <span className="template13-contact-label">Visit Us</span>
                      <span className="template13-contact-value">{clientConfig.contactInfo.address}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Navigation (Mobile) - Enhanced */}
          <div className="template13-bottom-nav">
            <a href={`tel:${clientConfig.contactInfo.phone1}`} className="template13-nav-item">
              <i className="fa fa-phone-alt"></i>
              <span>Call</span>
            </a>
            <a href={`mailto:${clientConfig.contactInfo.email}`} className="template13-nav-item">
              <i className="fa fa-envelope"></i>
              <span>Email</span>
            </a>
            <a href={`https://${clientConfig.contactInfo.website}`} target="_blank" rel="noopener noreferrer" className="template13-nav-item">
              <i className="fa fa-globe"></i>
              <span>Website</span>
            </a>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state.home,
  ...state.auth
});

const ConnectedEnquiryTemplate13 = connect(mapStateToProps)(EnquiryTemplate13);

function EnquiryTemplate13WithRouter(props) {
  const { clientId } = useParams();
  return <ConnectedEnquiryTemplate13 {...props} clientId={clientId} />;
}

export default EnquiryTemplate13WithRouter;
